import React, { useState } from 'react';
import { Container, Stack } from '@mui/material';
import SupportTicketForm from './SupportTicketForm';
import MyTickets from './MyTickets';

const SupportPage: React.FC = () => {
  // Bumped whenever a new ticket is submitted so the list reloads.
  const [refreshSignal, setRefreshSignal] = useState(0);

  return (
    <Container maxWidth="md" sx={{ mt: 2, mb: 4 }}>
      <Stack spacing={3}>
        <SupportTicketForm onSubmitted={() => setRefreshSignal((n) => n + 1)} />
        <MyTickets refreshSignal={refreshSignal} />
      </Stack>
    </Container>
  );
};

export default SupportPage;
